import * as React from 'react';
import styled, { css } from 'styled-components';

import 'pure-react-carousel/dist/react-carousel.es.css';
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  Dot,
} from 'pure-react-carousel';
import { getImagePath } from '../../../utilities/product';
import LightboxCustom from '../Lightbox/LightboxCustom';

import { rem } from 'polished';
import {
  NoItemsWrapper,
  FlexColCenter,
  GolfcentrumProductTabDefault as ProductTabDefault,
  GolfCentrumProductTabSmall as ProductTabSmall,
  ArticleTabDefault,
} from '@bart.sk-eshop/eshop-defaults';
import { prop } from '../../../utilities';
import { Link } from 'react-router';
import { __, __r } from '@bart.sk-eshop/react-i18n';

const DotComponent = styled(Dot)`
  width: 12px;
  height: 12px;
  border: none;
  border: 2px solid ${({ theme }) => theme.color.primary};
  background-color: ${({ theme }) => theme.color.primary};
  padding: 0;
  margin: 0 5.5px;
  border-radius: 50%;
  transition: 0.2s ease-in-out;

  &:disabled {
    background-color: ${({ theme }) => theme.color.white};
    cursor: default;
    width: 15px;
    height: 15px;
    padding: 2px 0;
    margin: 0 4px;
  }
`;

const Dots = styled.div`
  width: 100%;
  margin: auto;

  ${(props: any) => {
    const { theme, type } = props;
    switch (type) {
      case 'hp-banner': {
        return css`
          text-align: center;
          position: relative;
          right: auto;
          display: block;
          bottom: ${rem(40)};
          ${theme.mediab.l925`
              background: ${theme.color.white};
              display: block;
              bottom: 0;
              padding-top: ${rem(8)}
          `}
        `;
      }
      case 'article-product':
      case 'article-photogallery': {
        return css`
          text-align: center;
          position: relative;
          top: auto;
          right: auto;
          display: block;
          background: ${theme.color.white};
          padding: ${rem(16)} 0 0;
        `;
      }
      case 'add-to-cart-popup': {
        return css`
          text-align: right;
          position: absolute;
          top: ${rem(-32)};
          right: 0;
        `;
      }
      case 'product-detail': {
        return css`
          padding: ${rem(24)} 0;
          position: relative;
          top: auto;
          right: auto;
          text-align: center;
        `;
      }
      case 'hp-product': {
        return css`
          padding: ${rem(40)} 0;
          position: absolute;
          text-align: right;
          top: ${rem(-113)};
          right: 0;

          ${theme.mediab.l925`
            padding: ${rem(15)} 0 0 0;
            text-align: center;
            top: ${rem(-65)};
            width: 90vw;
          `}
        `;
      }
      case 'hp-article': {
        return css`
          padding: ${rem(40)} 0;
          position: absolute;
          text-align: right;
          top: ${rem(-113)};
          right: 0;

          ${theme.mediab.l925`
            padding: ${rem(15)} 0 0 0;
            text-align: center;
            top: ${rem(-50)};
          `}
        `;
      }
      case 'product': {
        return css`
          padding: ${rem(40)} 0;
          position: absolute;
          text-align: right;
          top: ${rem(-113)};
          right: 0;

          ${theme.mediab.l925`
              padding: ${rem(15)} 0 ${rem(15)} 0;
              text-align: right;
              top: ${rem(-3)};
          `}
        `;
      }
      default: {
        return css``;
      }
    }
  }};

  @media only screen and (max-width: 380px) {
    bottom: ${({ type }) => (type === 'ebook' ? '-220px' : 'initial')};
  }
  @media only screen and (max-width: 340px) {
    bottom: ${({ type }) => (type === 'ebook' ? '-200px' : 'initial')};
  }
`;

const BtnBack = styled(ButtonBack)`
  background-image: url('/images/golfcentrum/caret-left.svg');
  background-position: center center;
  background-repeat: no-repeat;
  background-color: rgba(255, 255, 255, 0.7);
  height: ${rem(40)};
  width: ${rem(40)};
  z-index: 9;
  border: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${rem(48)};
  outline: 0;
  border-radius: 50%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  &:disabled {
    display: none;
  }

  ${({ theme }) => theme.mediab.l925`
      display: none;
  `}
`;

const BtnNext = styled(ButtonNext)`
  outline: 0;
  background-image: url('/images/golfcentrum/caret-left.svg');
  background-position: center center;
  background-repeat: no-repeat;
  background-color: rgba(255, 255, 255, 0.7);
  height: ${rem(40)};
  width: ${rem(40)};
  border: none;
  z-index: 9;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(180deg);
  right: ${rem(48)};
  border-radius: 50%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  &:disabled {
    display: none;
  }

  ${({ theme }) => theme.mediab.l925`
      display: none;
  `}
`;

const Carousel = styled(CarouselProvider)`
  margin: auto;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
`;

const SliderCustom = styled(Slider)`
  height: 100%;
  ${({ type }) => {
    switch (type) {
      case 'product': {
        return css`
          margin-top: ${rem(42)};
        `;
      }
      default: {
        return css``;
      }
    }
  }}
`;

const SlideCustom = styled(Slide)`
height: 100%;
  /* margin-right: ${rem(32)}; */
`;

const ProductTabWrapper = styled.p`
  transition: 0.3s filter cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    filter: drop-shadow(0px 4px 8px rgba(163, 163, 163, 0.3));
  }
`;
const TabWrapper = styled(FlexColCenter)`
  /* margin-right: ${rem(32)}; */

  ${({ theme }) => theme.mediab.l925`
    &:nth-child(2n) {
      margin-right: 0;
    }
  `}

  ${({ theme }) => theme.mediab.m580`
    margin-right: 0;
  `}
`;

const PhotogalleryItem = styled(Link)<{ marginRight?: number }>`
  margin-right: ${({ marginRight }) =>
    marginRight || marginRight === 0 ? rem(marginRight) : 'initial'};
`;

const PhotogalleryCover = styled.img<{ marginRight?: number }>``;

const MagazinLink = styled(Link)`
  text-decoration: underline;
  font-family: ${({ theme }) => theme.font.primaryFont};
  color: ${({ theme }) => theme.color.textPrimary};
  line-height: ${rem(20)};
  font-weight: 600;
  text-transform: none;
  margin: 0 ${rem(20)};
  ${({ theme }) => theme.mediab.l925`
    margin: 0;
    position: absolute;
    left: 0;
    top: -10px
  `}
`;

export interface Props {
  type: string;
  slides: any;
  addToCart?: any;
  addToRequest?: any;
  maxSlidesVisible?: number;
  showButtons?: boolean;
  showDots?: boolean;
  user?: any;
  lightboxItems?: any;
  sectionLink?: string;
  sectionLinkText?: string;
  imageAlt?: string;
}

function SecondSlider({
  type,
  slides,
  addToCart,
  addToRequest,
  maxSlidesVisible = 4,
  user,
  showButtons = false,
  showDots = false,
  lightboxItems = [],
  sectionLink,
  sectionLinkText,
  imageAlt,
}: Props) {
  const [state, setState]: any = React.useState({
    width: 330,
    height: 192,
    visibleSlides: 4,
    step: type === 'product' ? 1 : 0,
  });

  const [isLightboxOpen, setIsLightboxOpen] = React.useState(false);
  const [itemIndex, setItemIndex]: any = React.useState(0);

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  const openLightbox = () => {
    setIsLightboxOpen(true);
  };
  const handleLightboxAction = index => {
    setItemIndex(index);
    setIsLightboxOpen(!isLightboxOpen);
  };

  const renderDots = (items: any[], slide: number) => {
    const table: any[] = [];
    for (let i = 0; i < items.length; i += slide) {
      table.push(<DotComponent slide={i} key={i} />);
    }
    return table;
  };

  const updateState = React.useCallback(
    win => {
      if (type === 'product') {
        if (win > 1450) {
          setState({
            ...state,
            width: 330,
            height: 520,
            visibleSlides: 4,
          });
        } else if (win <= 1450 && win >= 1260) {
          setState({
            ...state,
            width: 300,
            height: 520,
            visibleSlides: 4,
          });
        } else if (win <= 1260 && win >= 1100) {
          setState({
            ...state,
            width: 450,
            height: 600,
            visibleSlides: 3,
          });
        } else if (win <= 1100 && win >= 975) {
          setState({
            ...state,
            width: 300,
            height: 550,
            visibleSlides: 3,
          });
        } else if (win < 975 && win >= 830) {
          setState({
            ...state,
            width: 280,
            height: 550,
            visibleSlides: 3,
          });
        } else if (win < 830 && win >= 750) {
          setState({
            ...state,
            width: 330,
            height: 510,
            visibleSlides: 2,
          });
        } else if (win < 750 && win >= 620) {
          setState({
            ...state,
            width: 290,
            height: 480,
            visibleSlides: 2,
          });
        } else if (win < 620 && win >= 550) {
          setState({
            ...state,
            width: 500,
            height: 510,
            visibleSlides: 1,
          });
        } else if (win < 550 && win >= 480) {
          setState({
            ...state,
            width: 500,
            height: 510,
            visibleSlides: 1,
          });
        } else if (win < 480 && win >= 440) {
          setState({
            ...state,
            width: 400,
            height: 510,
            visibleSlides: 1,
          });
        } else if (win < 440 && win >= 420) {
          setState({
            ...state,
            width: 400,
            height: 510,
            visibleSlides: 1,
          });
        } else if (win < 420 && win >= 380) {
          setState({
            ...state,
            width: 350,
            height: 510,
            visibleSlides: 1,
          });
        } else if (win < 420 && win >= 380) {
          setState({
            ...state,
            width: 300,
            height: 510,
            visibleSlides: 1,
          });
        } else {
          setState({
            ...state,
            width: 300,
            height: 600,
            visibleSlides: 1,
          });
        }
      } else if (type === 'photogallery' || type === 'product-detail') {
        setState({
          width: 480,
          height: 480,
          visibleSlides: 1,
        });
      } else if (type === 'addToCartProduct') {
        setState({
          ...state,
          width: 288,
          visibleSlides: 2,
        });
      } else if (type === 'hp-banner') {
        if (win > 925) {
          setState({
            ...state,
            height: 480,
            width: 1920,
            visibleSlides: 1,
          });
        } else {
          setState({
            ...state,
            height: 386,
            width: 320,
            visibleSlides: 1,
          });
        }
      } else if (type === 'hp-product') {
        if (win > 925) {
          setState({
            ...state,
            height: 446,
            visibleSlides: 3,
          });
        } else if (win > 760) {
          setState({
            ...state,
            height: 354,
            visibleSlides: 2,
          });
        } else if (win > 540) {
          setState({
            ...state,
            height: 390,
            visibleSlides: 2,
          });
        } else if (win > 431) {
          setState({
            ...state,
            height: 460,
            visibleSlides: 2,
          });
        } else {
          setState({
            ...state,
            height: 760,
            visibleSlides: 2,
          });
        }
      } else if (type === 'hp-article') {
        if (win > 925) {
          setState({
            ...state,
            height: 375,
            visibleSlides: 4,
          });
        } else {
          setState({
            ...state,
            height: 375,
            visibleSlides: 1,
          });
        }
      } else if (type === 'article-product') {
        if (win > 720 || true) {
          setState({
            ...state,
            height: 400,
            visibleSlides: 2,
          });
        }
      } else if (type === 'article-photogallery') {
        if (win > 720 || true) {
          setState({
            ...state,
            height: 350,
            visibleSlides: 3,
          });
        }
      } else if (type === 'add-to-cart-popup') {
        if (win > 1130 || true) {
          setState({
            ...state,
            height: 80,
            visibleSlides: 2,
          });
        }
      }
    },
    [type, state],
  );

  React.useEffect(() => {
    updateState(window.innerWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const handleResize = () => updateState(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [updateState]);

  const { width, height, visibleSlides, step } = state;
  const renderItem = (key: number, img: string, item: any) => {
    if (type === 'addToCartProduct') {
      return (
        <TabWrapper>
          <ProductTabSmall
            key={item.product_id}
            // tslint:disable-next-line:jsx-no-lambda
            // tslint:disable-next-line:jsx-no-lambda
            product={item}
          />
        </TabWrapper>
      );
    } else if (type === 'product-detail') {
      return (
        <PhotogalleryItem key={key}>
          <PhotogalleryCover
            alt={
              imageAlt ? `${imageAlt} (${key + 1})` : __('Fotografia produktu')
            }
            src={getImagePath(item, { width: 800, height: 800 })}
          />
        </PhotogalleryItem>
      );
    } else if (type === 'hp-banner') {
      return (
        <PhotogalleryItem key={key} to={item.b_url}>
          <PhotogalleryCover
            alt={`Banner č. ${key}`}
            src={getImagePath(
              item.b_path,
              {
                width: item.device === 'phone' ? 925 : 1920,
                height: 0,
              },
              false,
              false,
            )}
          />
        </PhotogalleryItem>
      );
    } else if (type === 'hp-product') {
      return (
        <ProductTabDefault
          key={item.product_id}
          addToCart={''}
          addToRequest={''}
          product={item}
          inArticle={true}
        />
      );
    } else if (type === 'product') {
      return (
        <ProductTabWrapper>
          <ProductTabDefault
            key={item.product_id}
            addToCart={''}
            addToRequest={''}
            product={item}
            inArticle={true}
            showVariants={true}
          />
        </ProductTabWrapper>
      );
    } else if (type === 'hp-article') {
      return (
        <ArticleTabDefault
          key={key}
          article={item}
          anotationAsTitle={false}
          showCategory={true}
        />
      );
    } else if (type === 'article-product') {
      return (
        <ProductTabDefault
          key={item.product_id}
          addToCart={''}
          addToRequest={''}
          product={item}
          inArticle={true}
        />
      );
    } else if (type === 'article-photogallery') {
      return (
        <PhotogalleryItem
          key={key}
          marginRight={8}
          title={key}
          onClick={() => handleLightboxAction(key)}
        >
          <PhotogalleryCover
            alt={imageAlt || __('Obrázok vo fotogalérii')}
            src={getImagePath(
              item.document_path,
              { width: 256, height: 256 },
              false,
              false,
              false,
            )}
          />
        </PhotogalleryItem>
      );
    } else if (type === 'add-to-cart-popup') {
      return (
        <ProductTabSmall
          key={item.product_id}
          product={item}
          maxWidth={width}
        />
      );
    }
    return null;
  };

  // window.addEventListener('resize', this.updateState);
  // window.removeEventListener('resize', this.updateState);

  return (
    <>
      {/* {slides && slides.length > 0 ? ( */}
      <Carousel
        naturalSlideHeight={height}
        naturalSlideWidth={width}
        visibleSlides={
          visibleSlides > maxSlidesVisible ? maxSlidesVisible : visibleSlides
        }
        isPlaying={true}
        step={step ? step : visibleSlides}
        totalSlides={slides.length}
      >
        {showButtons && <BtnBack type={type} />}
        <SliderCustom type={type}>
          {slides.map((item, index) => {
            return (
              <SlideCustom
                innerClassName="sliderCentered"
                index={index}
                key={index}
              >
                {renderItem(index, item.img ? item.img : '', item)}
              </SlideCustom>
            );
          })}
          {lightboxItems && lightboxItems.length > 0 && (
            <LightboxCustom
              items={lightboxItems}
              isLightboxOpen={isLightboxOpen}
              onCloseRequest={closeLightbox}
              itemIndex={itemIndex}
              setItemIndex={setItemIndex}
            />
          )}
        </SliderCustom>
        {showButtons && <BtnNext type={type} />}
        {showDots && (
          <Dots type={type}>
            {type === 'hp-article' && sectionLink && (
              <MagazinLink to={sectionLink}>
                {sectionLinkText || __('Prejsť na magazín')}
              </MagazinLink>
            )}

            {renderDots(slides, visibleSlides)}
          </Dots>
        )}
      </Carousel>
      {/* ) : (
          <NoItemsWrapper text={'Nenašli sa žiadne produkty'} />
        )} */}
    </>
  );
}

export default SecondSlider;
